import React from 'react';

export const SplashMessageContext = React.createContext({
  messages: [],
  addMessage: () => {}
});



// WEBPACK FOOTER //
// ./src/components/splashMessage/SplashMessageContext.js